import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { spacesApi } from '@/lib/api';
import type { CreateSpaceRequest } from '@arkitekt/shared';

interface UseSpacesOptions {
  page?: number;
  limit?: number;
  includePublic?: boolean;
}

export function useSpaces(options?: UseSpacesOptions) {
  return useQuery({
    queryKey: ['spaces', options],
    queryFn: () => spacesApi.list(options),
  });
}

export function useSpace(spaceId: string | undefined) {
  return useQuery({
    queryKey: ['space', spaceId],
    queryFn: () => spacesApi.get(spaceId!),
    enabled: !!spaceId,
  });
}

export function useSpaceByKey(key: string | undefined) {
  return useQuery({
    queryKey: ['space', 'key', key],
    queryFn: () => spacesApi.getByKey(key!),
    enabled: !!key,
  });
}

export function useCreateSpace() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: CreateSpaceRequest) => spacesApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['spaces'] });
    },
  });
}
